export default "__VITE_ASSET__59a0b297__"